exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*!\n * Copyright (c) 2014-2024 Comparatio USA  LLC. <https://www.comparatio.com>\n */\n.ellipsed-text {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap; }\n.wrap {\n  white-space: pre-wrap; }\n.download-button {\n  color: #63c2de;\n  border: 0;\n  background-color: transparent;\n  margin-right: 15px;\n  padding: 5px; }\n.download-radio-group {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  padding: 15px; }\n.download-radio-button {\n  margin: 5px; }\n.overlayMessage {\n  position: absolute;\n  z-index: 999;\n  background-color: #f86c6b;\n  color: #29363d;\n  border: 3px solid #29363d;\n  padding: 5px 10px;\n  left: 45%;\n  top: 20%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/views/transaction-reports/transaction-duration-report-capacity/transaction-duration-report-capacity.component.scss
// module id = ../../../../../angular/app/views/transaction-reports/transaction-duration-report-capacity/transaction-duration-report-capacity.component.scss
// module chunks = main